import angular from 'angular';

import component from './languageSelector.component';

import logServiceModule from '../../service/LogService';
import translationServiceModule from '../../service/TranslationService';
import taskQueueServiceModule from '../../service/TaskQueueService';

let module = angular.module('recaps.components.languageSelector', [
  logServiceModule.name,
  translationServiceModule.name,
  taskQueueServiceModule.name,
]);

module.component('languageSelector', component);

export default module;
